module.exports = __webpack_public_path__ + "img/icon-type-3.9494764d.png";